/**
 * API client for shareable listing collections ("custom links").
 *
 * Admin endpoints are password-gated — pass the unlocked admin password
 * as `adminPass`. Public endpoints are read-only and require no auth.
 */
const API = process.env.REACT_APP_BACKEND_URL;

async function jsonOrThrow(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data?.detail || `Request failed (${res.status})`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function listCollections(adminPass) {
  const res = await fetch(`${API}/api/public/admin/collections?password=${encodeURIComponent(adminPass)}`);
  return jsonOrThrow(res);
}

export async function createCollection(adminPass, payload) {
  const res = await fetch(`${API}/api/public/admin/collections`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password: adminPass, ...payload }),
  });
  return jsonOrThrow(res);
}

export async function updateCollection(adminPass, collectionId, payload) {
  const res = await fetch(`${API}/api/public/admin/collections/${collectionId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password: adminPass, ...payload }),
  });
  return jsonOrThrow(res);
}

export async function deleteCollection(adminPass, collectionId) {
  const res = await fetch(`${API}/api/public/admin/collections/${collectionId}?password=${encodeURIComponent(adminPass)}`, {
    method: 'DELETE',
  });
  return jsonOrThrow(res);
}

export async function getPublicCollection(slug) {
  const res = await fetch(`${API}/api/public/c/${encodeURIComponent(slug)}`);
  return jsonOrThrow(res);
}

export async function getPublicCollectionListing(slug, listingId) {
  const res = await fetch(`${API}/api/public/c/${encodeURIComponent(slug)}/l/${encodeURIComponent(listingId)}`);
  return jsonOrThrow(res);
}
